import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {topicsData.title}
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.items.map((item) => {
            const isPrimary = item.color === 'primary';
            return (
              <div
                key={item.tag}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-lg cursor-pointer transition-all duration-200 hover:scale-105 ${
                  isPrimary
                    ? 'bg-primary-50 text-primary-700 hover:bg-primary-100'
                    : 'bg-accent-50 text-accent-700 hover:bg-accent-100'
                }`}
              >
                <span className="text-sm font-medium whitespace-nowrap">{item.tag}</span>
                <span
                  className={`text-xs font-bold ${
                    isPrimary ? 'text-primary-500' : 'text-accent-500'
                  }`}
                >
                  {item.heat}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}